export type Language = 'en' | 'es'

export const translations = {
  en: {
    header: {
      services: 'Services',
      portfolio: 'Portfolio',
      process: 'Process',
      whyUs: 'Why Us',
      areas: 'Service Areas',
    },
    hero: {
      headline:
        'Premier Painting & Remodeling Experts in League City Since 2001.',
      subheadline:
        '25 Years of Unmatched Craftsmanship. Residential & Commercial transformations with a 100% Satisfaction Guarantee.',
      primaryCta: 'Call Now — Free Estimate: (832) 439-7965',
      secondaryCta: 'View Our Portfolio',
      badge: 'Free Estimates • No Obligation • Same-Week Availability',
      anniversary: 'EST. 2001',
      anniversaryTag: '25TH ANNIVERSARY',
    },
    trustBar: {
      years: '25+ Years of Excellence',
      projects: '10,000+ Projects Completed',
      family: 'Family Owned & Local',
    },
    services: {
      title: 'Our Professional Services',
      subtitle: 'Interior & Exterior Remodeling Solutions',
      residential: {
        title: 'Residential Painting',
        desc: 'Transform your home with expert interior and exterior painting, cabinet refinishing, and color consultation. We use premium paints for lasting results.',
        full: `Our residential painting service covers every aspect of your home's appearance — inside and out.

INTERIOR PAINTING
• Living rooms, bedrooms, kitchens, bathrooms, hallways, and ceilings
• Accent walls and custom color schemes with professional color consultation
• Cabinet refinishing and painting — give your kitchen a brand-new look without a full remodel
• Trim, baseboards, crown molding, and door painting
• Wallpaper removal and surface preparation

EXTERIOR PAINTING
• Full exterior house painting including siding, trim, fascia, and soffits
• Deck and fence staining and painting
• Garage doors, shutters, and accent features
• Power washing and surface prep before every exterior job

We use only premium-grade paints from trusted brands like Sherwin-Williams and Benjamin Moore for lasting, beautiful results. Every project includes thorough surface preparation, priming, and clean-up.

Call us today for a free estimate — no obligation.`,
      },
      commercial: {
        title: 'Commercial Projects',
        desc: 'Professional painting solutions for offices, retail spaces, warehouses, and industrial facilities. Minimal disruption to your business operations.',
        full: `C&L Painting provides professional commercial painting and coating services for businesses of all sizes across the League City area.

WHAT WE COVER
• Office buildings — interior and exterior painting, lobby and common area refreshes
• Retail stores and shopping centers — brand-aligned color schemes and finishes
• Warehouses and industrial facilities — epoxy floor coatings, high-durability wall coatings
• Restaurants and hospitality — food-safe finishes, quick turnaround to minimize downtime
• HOA and multi-family properties — building exteriors, hallways, common areas

OUR COMMERCIAL ADVANTAGE
• Flexible scheduling — we work nights and weekends to avoid disrupting your business
• Owner-supervised crews on every job site
• Fully licensed, insured, and OSHA-compliant
• Detailed written estimates with no hidden costs
• 25+ years of commercial project experience

We understand that your business can't afford downtime. That's why we plan every commercial project to be completed on schedule with minimal disruption to your operations.

Call (832) 439-7965 for a free commercial estimate.`,
      },
      remodeling: {
        title: 'Interior & Exterior Remodeling',
        desc: 'Complete interior and exterior remodeling including kitchens, bathrooms, flooring, facades, patios, and full home renovations. From concept to completion, we handle it all — inside and out.',
        full: `From concept to completion, C&L Painting handles full interior and exterior remodeling projects for homes and businesses.

INTERIOR REMODELING
• Kitchen remodeling — custom cabinets, countertops, backsplashes, islands, and layout redesign
• Bathroom remodeling — showers, tubs, vanities, tile work, and fixtures
• Flooring installation — hardwood, laminate, tile, vinyl, and luxury vinyl plank (LVP)
• Room additions and layout modifications
• Closet and storage solutions
• Basement and attic finishing

EXTERIOR REMODELING
• Facade renovations and exterior cladding
• Patio and deck construction and renovation
• Outdoor kitchens and living spaces
• Siding replacement and repair
• Window and door replacement
• Fencing and landscaping hardscapes

WHY C&L FOR REMODELING?
• One contractor for the entire project — no juggling multiple companies
• Owner Jose Bustillo personally supervises every remodel
• Licensed for structural, electrical, and plumbing work
• 25 years of remodeling experience in the League City area
• Transparent pricing with detailed written estimates

Call us today to schedule your free in-home consultation.`,
      },
      drywall: {
        title: 'Drywall & Texture',
        desc: 'Expert drywall installation, repair, and custom texture finishing. We restore walls to perfection with seamless results.',
        full: `Our drywall and texture specialists deliver flawless walls and ceilings for new construction, remodels, and repairs.

DRYWALL SERVICES
• New drywall installation for additions, remodels, and new construction
• Drywall repair — holes, cracks, water damage, and settling damage
• Ceiling repair and replacement including popcorn ceiling removal
• Soundproofing and moisture-resistant drywall installation
• Garage drywall finishing

TEXTURE SERVICES
• Knockdown texture — the most popular choice for Texas homes
• Orange peel texture
• Skip trowel and hand-applied textures
• Smooth wall finishing
• Texture matching for seamless repairs
• Ceiling texture application and repair

OUR PROCESS
1. Thorough assessment of the area and existing conditions
2. Professional preparation — dust barriers, floor protection, furniture covering
3. Expert installation or repair with premium materials
4. Texture application matched perfectly to your existing walls
5. Final sanding, priming, and clean-up

We pride ourselves on our dust-free process — your home stays clean while we work.

Call (832) 439-7965 for a free drywall estimate.`,
      },
      roofing: {
        title: 'Roofing',
        desc: 'Professional roof installation, repair, and replacement for residential and commercial properties. We protect your investment with quality materials and expert craftsmanship.',
        full: `Protect your home or business with professional roofing services from C&L Painting. We handle everything from minor repairs to complete roof replacements.

RESIDENTIAL ROOFING
• Complete roof replacement — shingle, tile, and metal roofing options
• Storm damage repair and emergency patching
• Roof leak detection and repair
• Gutter installation, repair, and cleaning
• Attic ventilation and insulation improvements
• Skylight installation and repair

COMMERCIAL ROOFING
• Flat roof systems — TPO, EPDM, and modified bitumen
• Metal roofing for commercial buildings
• Roof maintenance programs and inspections
• Emergency leak repair

WHY CHOOSE C&L FOR ROOFING?
• Licensed and insured roofing contractors
• We work with all major insurance companies for storm damage claims
• Premium materials with manufacturer warranties
• Owner-supervised installation crews
• Free roof inspections and estimates
• 25 years of roofing experience in the Gulf Coast region

Don't wait until a small leak becomes a big problem. Call us today for a free roof inspection.`,
      },
      electrical: {
        title: 'Electrical Services',
        desc: 'Complete electrical solutions including wiring, panel upgrades, lighting installation, and outlet repairs. Safe, code-compliant work for your home or business.',
        full: `C&L Painting offers comprehensive electrical services for residential and commercial properties. All work is performed to code and inspected for safety.

RESIDENTIAL ELECTRICAL
• Electrical panel upgrades — 100 amp, 200 amp, and 400 amp services
• New circuit installation for additions, kitchens, and home offices
• Lighting installation — recessed lights, chandeliers, under-cabinet, and outdoor lighting
• Outlet and switch installation and replacement — including GFCI and USB outlets
• Ceiling fan installation and wiring
• Whole-home surge protection
• Smoke and carbon monoxide detector installation
• EV charger installation for electric vehicles

COMMERCIAL ELECTRICAL
• Office and retail lighting design and installation
• Electrical system upgrades and code compliance
• Emergency and exit lighting
• Data and communication wiring

SAFETY FIRST
• All work meets or exceeds local building codes
• Licensed electricians on every job
• Proper permitting and inspections
• 25 years of electrical experience

Electrical work is not a DIY job. Trust the professionals at C&L Painting for safe, reliable electrical services.

Call (832) 439-7965 for a free electrical estimate.`,
      },
      plumbing: {
        title: 'Plumbing',
        desc: 'Full plumbing services from pipe repair and fixture installation to bathroom and kitchen plumbing for remodels. Reliable solutions you can count on.',
        full: `From simple repairs to complete plumbing installations for remodels, C&L Painting delivers reliable plumbing services you can trust.

RESIDENTIAL PLUMBING
• Kitchen plumbing — sink installation, garbage disposal, dishwasher hookup, and faucet replacement
• Bathroom plumbing — toilet installation, shower and tub plumbing, vanity hookups
• Water heater installation and replacement — tank and tankless options
• Pipe repair and replacement — copper, PEX, and PVC
• Leak detection and repair
• Drain cleaning and unclogging
• Sewer line repair and replacement
• Water line installation and repair

REMODEL PLUMBING
• Rough-in plumbing for kitchen and bathroom remodels
• Fixture relocation — moving sinks, toilets, and showers to new locations
• Gas line installation for stoves, dryers, and outdoor grills
• Outdoor plumbing — hose bibs, irrigation connections, outdoor kitchens

WHY C&L FOR PLUMBING?
• Licensed plumbers on every job
• Same-day emergency service available
• Transparent pricing — no surprise charges
• We coordinate plumbing with your remodel for seamless results
• 25 years of plumbing experience

Don't let a plumbing issue become a disaster. Call us today for fast, professional service.`,
      },
      cta: 'Learn More',
      callNow: 'Call Now for a Free Estimate',
    },
    portfolio: {
      title: 'Our Recent Projects',
      cta: 'Start Your Project Today',
      labels: {
        residentialCommercial: 'Residential & Commercial',
        teamAtWork: 'Our Team at Work',
        interiorPainting: 'Interior Painting',
        exteriorPainting: 'Exterior Painting',
        electrical: 'Electrical & Construction',
        interiorFinish: 'Interior Finishing',
        commercialResidential: 'Commercial & Residential',
        roofing: 'Roofing Services',
        professionalTeam: 'Professional Team',
        residentialProjects: 'Residential Projects',
      },
    },
    process: {
      title: 'Our Proven Process',
      steps: [
        {
          title: 'Free Consultation',
          desc: 'We assess your project needs and provide a detailed estimate — no obligation, no pressure.',
        },
        {
          title: 'Planning & Prep',
          desc: 'Detailed planning, material selection, and surface preparation.',
        },
        {
          title: 'Expert Execution',
          desc: 'Owner-supervised work with premium materials and techniques.',
        },
        {
          title: 'Final Walkthrough',
          desc: "100% satisfaction guaranteed. We don't leave until you're happy.",
        },
      ],
    },
    testimonials: {
      title: 'What Our Clients Say',
      reviews: [
        {
          quote:
            'C&L Painting transformed our entire home. Jose personally supervised every detail. The quality is outstanding!',
          author: 'Maria G.',
          location: 'League City',
        },
        {
          quote:
            'Best painting contractor in the area. Professional, clean, and on time. Our office looks brand new.',
          author: 'Robert T.',
          location: 'Webster',
        },
        {
          quote:
            'From kitchen remodel to exterior painting, they did it all. Highly recommend C&L Painting!',
          author: 'Sandra L.',
          location: 'Friendswood',
        },
      ],
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know before getting started',
      items: [
        {
          q: 'How much does a free estimate cost?',
          a: 'Absolutely nothing. Our estimates are 100% free with no obligation. We come to your property, assess the work, and provide a detailed written quote — no pressure, no hidden fees.',
        },
        {
          q: 'Are you licensed and insured?',
          a: "Yes. C&L Painting is fully licensed and insured in the state of Texas. We carry general liability insurance and workers' compensation to protect you and your property.",
        },
        {
          q: 'How soon can you start my project?',
          a: "We typically have same-week or next-week availability depending on the scope of work. Call us today and we'll schedule your free consultation as soon as possible.",
        },
        {
          q: 'Do you offer a warranty on your work?',
          a: "Yes. We stand behind every project with a workmanship warranty. If anything isn't right, we'll come back and fix it at no additional cost.",
        },
        {
          q: 'What areas do you serve?',
          a: 'We serve League City and all communities within a 30-mile radius including Dickinson, Webster, Friendswood, Pearland, Pasadena, Clear Lake, Galveston, and more.',
        },
        {
          q: 'Do you handle both residential and commercial projects?',
          a: 'Yes. From single-family homes to large commercial buildings, we have 25+ years of experience handling projects of all sizes — interior and exterior.',
        },
      ],
    },
    serviceArea: {
      title: 'Excellence Within 30 Miles of League City',
      cities: [
        'League City',
        'Dickinson',
        'Webster',
        'Friendswood',
        'Pearland',
        'Pasadena',
        'Houston (South)',
        'Galveston',
        'Texas City',
        'La Marque',
        'Santa Fe',
        'Kemah',
        'Seabrook',
        'Alvin',
        'Clear Lake',
      ],
    },
    whyUs: {
      title: 'Why Choose C&L Painting?',
      points: [
        'Fully Licensed & Insured in Texas',
        'Trusted Since 2001 — 10,000+ Projects',
        'Owner-Supervised on Every Job',
        'Dust-Free, Clean Work Process',
        'Free Estimates — No Obligation',
        '100% Satisfaction Guarantee',
      ],
      cta: 'Call Us Today',
    },
    footer: {
      title: 'Your Home Deserves the Best.',
      contactHeader: 'Contact',
      areaHeader: 'League City, TX',
      areaDesc:
        'Serving residential and commercial clients within a 30-mile radius with premium painting, remodeling, roofing, electrical, and plumbing services.',
      ownersLabel: 'Family Owned & Operated',
      owner1: 'Maria Bustillo — Owner',
      email: 'clpaintingremodeling@gmail.com',
      copyright: '© 2001 C&L Painting. Professionalism at every stroke.',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      builtBy: 'Website built by THE DOCTOR ECOMMERCE',
    },
    legal: {
      terms: {
        title: 'Terms of Service',
        content: `1. Scope of Work: C&L Painting agrees to provide the painting, remodeling, roofing, electrical, and plumbing services as detailed in the approved estimate.
2. Payment Terms: A deposit is required before work begins. The remaining balance is due upon completion and final walkthrough.
3. Warranty: We offer a standard warranty on our workmanship. Materials are covered by the manufacturer's warranty.
4. Liability: C&L Painting is fully licensed and insured in the state of Texas. We take utmost care of your property during the project.
5. Cancellation: Cancellations must be made at least 48 hours before the scheduled start date.
6. Satisfaction Guarantee: We are committed to your 100% satisfaction. If any aspect of our work does not meet your expectations, we will return to address it at no additional cost.`,
      },
      privacy: {
        title: 'Privacy Policy',
        content: `1. Data Collection: We collect personal information such as name, phone number, email, and address solely for the purpose of providing estimates and services.
2. Data Usage: Your information is used only by C&L Painting to communicate with you regarding your project.
3. Third Parties: We do not sell, trade, or otherwise transfer your personal information to outside parties.
4. Cookies: Our website may use cookies to enhance user experience.
5. Contact: For any privacy-related concerns, please contact us at clpaintingremodeling@gmail.com or (832) 439-7965.`,
      },
    },
    floatingCta: 'Call Now — Free Estimate',
  },
  es: {
    header: {
      services: 'Servicios',
      portfolio: 'Portafolio',
      process: 'Proceso',
      whyUs: 'Por Qué Nosotros',
      areas: 'Áreas',
    },
    hero: {
      headline: 'Expertos en Pintura y Remodelación en League City Desde 2001.',
      subheadline:
        '25 Años de Artesanía Inigualable. Transformaciones Residenciales y Comerciales con Garantía de Satisfacción 100%.',
      primaryCta: 'Llame Ahora — Estimado Gratis: (832) 439-7965',
      secondaryCta: 'Ver Nuestro Portafolio',
      badge: 'Estimados Gratis • Sin Compromiso • Disponibilidad Inmediata',
      anniversary: 'EST. 2001',
      anniversaryTag: '25 ANIVERSARIO',
    },
    trustBar: {
      years: '25+ Años de Excelencia',
      projects: '10,000+ Proyectos Completados',
      family: 'Empresa Familiar y Local',
    },
    services: {
      title: 'Nuestros Servicios Profesionales',
      subtitle: 'Soluciones de Remodelación Interior y Exterior',
      residential: {
        title: 'Pintura Residencial',
        desc: 'Transforme su hogar con pintura interior y exterior experta, renovación de gabinetes y consulta de color. Usamos pinturas premium para resultados duraderos.',
        full: `Nuestro servicio de pintura residencial cubre todos los aspectos de la apariencia de su hogar — por dentro y por fuera.

PINTURA INTERIOR
• Salones, dormitorios, cocinas, baños, pasillos y techos
• Paredes de énfasis y esquemas de color personalizados con consulta profesional de color
• Refinado y pintura de gabinetes — dale a tu cocina un aspecto completamente nuevo sin necesidad de remodelar completamente
• Cenefas, bajantes, molduras y pintura de puertas
• Eliminación de papel pintado y preparación de superficies

PINTURA EXTERIOR
• Pintura completa de la casa exterior incluyendo fachadas, cenefas, fascias y soffits
• Tintado y pintura de deck y jardines
• Puertas de garaje, cortinas y elementos de énfasis
• Limpieza de superficies y preparación antes de cada trabajo exterior

Usamos solo pinturas de alta calidad de marcas confiables como Sherwin-Williams y Benjamin Moore para resultados duraderos y hermosos. Cada proyecto incluye preparación exhaustiva de superficies, aplicación de pintura y limpieza.

Llámanos hoy para un estimado gratuito — sin compromiso.`,
      },
      commercial: {
        title: 'Proyectos Comerciales',
        desc: 'Soluciones profesionales de pintura para oficinas, espacios comerciales, almacenes e instalaciones industriales. Mínima interrupción a sus operaciones.',
        full: `C&L Painting ofrece servicios profesionales de pintura y recubrimiento para negocios de todos los tamaños en la zona de League City.

LO QUE COBERTO
• Edificios oficina — pintura interior y exterior, actualizaciones de lobby y áreas comunes
• Tiendas y centros comerciales — esquemas de color y acabados alineados con la marca
• Almacenes e instalaciones industriales — recubrimientos de piso epoxi, recubrimientos de paredes de alta durabilidad
• Restaurantes y servicios — acabados seguros para alimentos, tiempo corto para minimizar el tiempo de inactividad
• Propiedades de asociación y multifamiliares — fachadas, pasillos, áreas comunes

NUESTRO AVANTAJE COMERCIAL
• Programación flexible — trabajamos noches y fines de semana para evitar interrumpir su negocio
• Equipos supervisados por el dueño en cada sitio
• Completamente licenciados, asegurados y OSHA-compliants
• Estimados escritos detallados sin costos ocultos
• Más de 25 años de experiencia en proyectos comerciales

Entendemos que su negocio no puede permitirse el tiempo de inactividad. Por eso, planificamos cada proyecto comercial para que se complete en tiempo y con mínima interrupción a sus operaciones.

Llámanos hoy para un estimado comercial gratuito.`,
      },
      remodeling: {
        title: 'Remodelación Interior y Exterior',
        desc: 'Remodelación completa interior y exterior incluyendo cocinas, baños, pisos, fachadas, patios y renovaciones completas del hogar. Desde el concepto hasta la finalización, lo manejamos todo — por dentro y por fuera.',
        full: `Desde el concepto hasta la finalización, C&L Painting maneja proyectos completos de remodelación interior y exterior para hogares y negocios.

REMODELACIÓN INTERIOR
• Remodelación de cocina — gabinetes personalizados, countertops, backsplashes, islas y rediseño de layout
• Remodelación de baño — duchas, baños, vanidades, trabajo de azulejos y fijaciones
• Instalación de pisos — madera, laminado, azulejos, vinilo y placa de vinilo de lujo (LVP)
• Añadidos de habitaciones y modificaciones de layout
• Soluciones de closet y almacenamiento
• Finalización de sótano y sótano

REMODELACIÓN EXTERIOR
• Renovaciones de fachadas y cladding exterior
• Construcción y renovación de patios y deck
• Cocinas y espacios exteriores
• Reemplazo y reparación de fachadas
• Reemplazo de ventanas y puertas
• Fencing y paisajes de duros

¿POR QUÉ C&L PARA REMODELACIÓN?
• Un contratista para todo el proyecto — sin tener que manejar múltiples empresas
• Dueño Jose Bustillo supervisa personalmente cada remodelación
• Licenciado para trabajo estructural, eléctrico y de plomería
• 25 años de experiencia en remodelación en la zona de League City
• Precios transparentes con estimados escritos detallados

Llámanos hoy para programar tu consulta gratuita en casa.`,
      },
      drywall: {
        title: 'Drywall y Textura',
        desc: 'Instalación experta de drywall, reparación y acabados de textura personalizados. Restauramos paredes a la perfección con resultados impecables.',
        full: `Nuestros especialistas en drywall y textura entregan paredes y techos perfectos para nuevas construcciones, remodelaciones y reparaciones.

SERVICIOS DE DRYWALL
• Instalación de drywall nuevo para añadidos, remodelaciones y nuevas construcciones
• Reparación de drywall — hoyos, grietas, daños por agua y daños por asentamiento
• Reparación y reemplazo de techos incluyendo eliminación de techos de pop
• Instalación de drywall aislante y resistente al humedad
• Finalización de drywall de garaje

SERVICIOS DE TEXTURA
• Textura knockdown — la opción más popular para casas de Texas
• Textura de naranja
• Texturas de salto y aplicadas a mano
• Finalización de paredes lisas
• Coincidencia de texturas para reparaciones sin juntas
• Aplicación y reparación de texturas de techos

NUESTRO PROCESO
1. Evaluación exhaustiva del área y condiciones existentes
2. Preparación profesional — barreras de polvo, protección de suelos, cubrimiento de muebles
3. Instalación o reparación experta con materiales premium
4. Aplicación de textura perfectamente coincidente con sus paredes existentes
5. Finalización con lijado, aplicación de pintura y limpieza

Nos enorgullece nuestro proceso sin polvo — su hogar se mantiene limpio mientras trabajamos.

Llámanos hoy para un estimado gratuito de drywall.`,
      },
      roofing: {
        title: 'Techos',
        desc: 'Instalación, reparación y reemplazo profesional de techos para propiedades residenciales y comerciales. Protegemos su inversión con materiales de calidad y mano de obra experta.',
        full: `Proteja su hogar o negocio con servicios profesionales de techos de C&L Painting. Manejamos todo desde reparaciones menores hasta reemplazo completo de techos.

TECHOS RESIDENCIALES
• Reemplazo completo de techos — opciones de techos, azulejos y metal
• Reparación de daños por tormentas y parches de emergencia
• Detección y reparación de fugas de techos
• Instalación, reparación y limpieza de goteo
• Mejoras de ventilación y aislamiento del sótano
• Instalación y reparación de techos de techo

TECHOS COMERCIALES
• Sistemas de techos planos — TPO, EPDM y bitumen modificado
• Techos metálicos para edificios comerciales
• Programas de mantenimiento y revisiones de techos
• Reparación de fugas de emergencia

¿POR QUÉ ELEGIR C&L PARA TECHOS?
• Contratistas de techos licenciados y asegurados
• Trabajamos con todas las principales compañías de seguros para reclamaciones por daños por tormentas
• Materiales premium con garantías del fabricante
• Equipos supervisados por el dueño
• Inspecciones y estimados gratuitos de techos
• 25 años de experiencia en techos en la región del Golfo

No espere hasta que una pequeña fuga se convierta en un gran problema. Llámanos hoy para una inspección gratuita de techos.`,
      },
      electrical: {
        title: 'Servicios Eléctricos',
        desc: 'Soluciones eléctricas completas incluyendo cableado, actualización de paneles, instalación de iluminación y reparación de tomacorrientes. Trabajo seguro y conforme al código para su hogar o negocio.',
        full: `C&L Painting ofrece servicios eléctricos completos para propiedades residenciales y comerciales. Todos los trabajos se realizan conforme al código y se inspeccionan para la seguridad.

TECHOS RESIDENCIALES
• Actualización de paneles eléctricos — servicios de 100 amperios, 200 amperios y 400 amperios
• Instalación de circuitos nuevos para añadidos, cocinas y oficinas domésticas
• Instalación de iluminación — luces retraídas, cúpulas, bajo encimera y iluminación exterior
• Instalación y reemplazo de tomacorrientes y interruptores — incluyendo tomacorrientes GFCI y USB
• Instalación y cableado de ventiladores de techo
• Protección de sobrecarga en toda casa
• Instalación de detectores de humo y monóxido de carbono
• Instalación de cargadores de vehículos eléctricos

TECHOS COMERCIALES
• Diseño e instalación de iluminación para oficinas y comercio
• Actualización de sistemas eléctricos y cumplimiento del código
• Iluminación de emergencia y salidas
• Cableado de datos y comunicación

PRIMERO EN SEGURIDAD
• Todos los trabajos cumplen o superan los códigos locales
• Electricistas licenciados en cada trabajo
• Permisos y revisiones adecuadas
• 25 años de experiencia en electricidad

El trabajo eléctrico no es un trabajo de DIY. Confíe en los profesionales de C&L Painting para servicios eléctricos seguros y confiables.

Llámanos hoy para un estimado eléctrico gratuito.`,
      },
      plumbing: {
        title: 'Plomería',
        desc: 'Servicios completos de plomería desde reparación de tuberías e instalación de accesorios hasta plomería de baños y cocinas para remodelaciones. Soluciones confiables en las que puede confiar.',
        full: `Desde reparaciones simples hasta instalaciones completas de plomería para remodelaciones, C&L Painting entrega servicios de plomería confiables que puede confiar.

TECHOS RESIDENCIALES
• Plomería de cocina — instalación de fregadero, desagüe, conexión de lavadora y reemplazo de grifos
• Plomería de baño — instalación de inodoro, plomería de ducha y bañera, conexiones de vanidad
• Instalación y reemplazo de calentadores de agua — opciones de tanque y sin tanque
• Reparación y reemplazo de tuberías — cobre, PEX y PVC
• Detección y reparación de fugas
• Limpieza de desagües y desobstrucción
• Reparación y reemplazo de líneas de alcantarillado
• Instalación y reparación de líneas de agua

REMODEL PLUMMER
• Plomería de "rough-in" para remodelaciones de cocina y baño
• Reubicación de fijaciones — moviendo fregaderos, inodoro y duchas a nuevas ubicaciones
• Instalación de líneas de gas para estufas, secadoras y fogones al aire libre
• Plomería al aire libre — tomas de grifo, conexiones de riego, cocinas al aire libre

¿POR QUÉ C&L PARA PLUMMER?
• Plomeros licenciados en cada trabajo
• Servicio de emergencia disponible el mismo día
• Precios transparentes — sin cargos sorpresa
• Coordinamos plomería con su remodelación para resultados sin juntas
• 25 años de experiencia en plomería

No deje que un problema de plomería se convierta en un desastre. Llámanos hoy para servicio profesional rápido.`,
      },
      cta: 'Saber Más',
      callNow: 'Llame Ahora para un Estimado Gratis',
    },
    portfolio: {
      title: 'Nuestros Proyectos Recientes',
      cta: 'Comience Su Proyecto Hoy',
      labels: {
        residentialCommercial: 'Residencial y Comercial',
        teamAtWork: 'Nuestro Equipo en Acción',
        interiorPainting: 'Pintura Interior',
        exteriorPainting: 'Pintura Exterior',
        electrical: 'Eléctrico y Construcción',
        interiorFinish: 'Acabados Interiores',
        commercialResidential: 'Comercial y Residencial',
        roofing: 'Servicios de Techos',
        professionalTeam: 'Equipo Profesional',
        residentialProjects: 'Proyectos Residenciales',
      },
    },
    process: {
      title: 'Nuestro Proceso Comprobado',
      steps: [
        {
          title: 'Consulta Gratuita',
          desc: 'Evaluamos las necesidades de su proyecto y proporcionamos un presupuesto detallado — sin compromiso, sin presión.',
        },
        {
          title: 'Planificación y Prep',
          desc: 'Planificación detallada, selección de materiales y preparación de superficies.',
        },
        {
          title: 'Ejecución Experta',
          desc: 'Trabajo supervisado por el dueño con materiales y técnicas premium.',
        },
        {
          title: 'Revisión Final',
          desc: 'Satisfacción 100% garantizada. No nos vamos hasta que esté satisfecho.',
        },
      ],
    },
    testimonials: {
      title: 'Lo Que Dicen Nuestros Clientes',
      reviews: [
        {
          quote:
            'C&L Painting transformó toda nuestra casa. Jose supervisó personalmente cada detalle. ¡La calidad es excepcional!',
          author: 'Maria G.',
          location: 'League City',
        },
        {
          quote:
            'El mejor contratista de pintura en el área. Profesional, limpio y puntual. Nuestra oficina luce como nueva.',
          author: 'Robert T.',
          location: 'Webster',
        },
        {
          quote:
            'Desde remodelación de cocina hasta pintura exterior, lo hicieron todo. ¡Altamente recomendado C&L Painting!',
          author: 'Sandra L.',
          location: 'Friendswood',
        },
      ],
    },
    faq: {
      title: 'Preguntas Frecuentes',
      subtitle: 'Todo lo que necesita saber antes de comenzar',
      items: [
        {
          q: '¿Cuánto cuesta un estimado?',
          a: 'Absolutamente nada. Nuestros estimados son 100% gratis y sin compromiso. Visitamos su propiedad, evaluamos el trabajo y proporcionamos un presupuesto detallado por escrito — sin presión, sin costos ocultos.',
        },
        {
          q: '¿Están licenciados y asegurados?',
          a: 'Sí. C&L Painting está completamente licenciado y asegurado en el estado de Texas. Contamos con seguro de responsabilidad general y compensación de trabajadores para protegerlo a usted y su propiedad.',
        },
        {
          q: '¿Qué tan pronto pueden comenzar mi proyecto?',
          a: 'Generalmente tenemos disponibilidad para la misma semana o la siguiente dependiendo del alcance del trabajo. Llámenos hoy y programaremos su consulta gratuita lo antes posible.',
        },
        {
          q: '¿Ofrecen garantía en su trabajo?',
          a: 'Sí. Respaldamos cada proyecto con una garantía de mano de obra. Si algo no está bien, regresaremos a corregirlo sin costo adicional.',
        },
        {
          q: '¿Qué áreas atienden?',
          a: 'Servimos a League City y todas las comunidades dentro de un radio de 30 millas incluyendo Dickinson, Webster, Friendswood, Pearland, Pasadena, Clear Lake, Galveston y más.',
        },
        {
          q: '¿Manejan proyectos residenciales y comerciales?',
          a: 'Sí. Desde casas unifamiliares hasta grandes edificios comerciales, tenemos más de 25 años de experiencia manejando proyectos de todos los tamaños — interior y exterior.',
        },
      ],
    },
    serviceArea: {
      title: 'Excelencia a 30 Millas de League City',
      cities: [
        'League City',
        'Dickinson',
        'Webster',
        'Friendswood',
        'Pearland',
        'Pasadena',
        'Houston (Sur)',
        'Galveston',
        'Texas City',
        'La Marque',
        'Santa Fe',
        'Kemah',
        'Seabrook',
        'Alvin',
        'Clear Lake',
      ],
    },
    whyUs: {
      title: '¿Por Qué Elegir C&L Painting?',
      points: [
        'Totalmente Licenciados y Asegurados en Texas',
        'Confianza Desde 2001 — 10,000+ Proyectos',
        'Supervisión del Dueño en Cada Trabajo',
        'Proceso de Trabajo Limpio y Sin Polvo',
        'Estimados Gratis — Sin Compromiso',
        'Garantía de Satisfacción 100%',
      ],
      cta: 'Llámenos Hoy',
    },
    footer: {
      title: 'Su Hogar Merece lo Mejor.',
      contactHeader: 'Contacto',
      areaHeader: 'League City, TX',
      areaDesc:
        'Sirviendo a clientes residenciales y comerciales dentro de un radio de 30 millas con servicios premium de pintura, remodelación, techos, electricidad y plomería.',
      ownersLabel: 'Empresa Familiar',
      owner1: 'Maria Bustillo — Dueña',
      email: 'clpaintingremodeling@gmail.com',
      copyright: '© 2001 C&L Painting. Profesionalismo en cada trazo.',
      terms: 'Términos de Servicio',
      privacy: 'Política de Privacidad',
      builtBy: 'Sitio web construido por THE DOCTOR ECOMMERCE',
    },
    legal: {
      terms: {
        title: 'Términos de Servicio',
        content: `1. Alcance del Trabajo: C&L Painting acuerda proporcionar los servicios de pintura, remodelación, techos, electricidad y plomería detallados en el presupuesto aprobado.
2. Términos de Pago: Se requiere un depósito antes de comenzar el trabajo. El saldo restante se debe al finalizar y en la revisión final.
3. Garantía: Ofrecemos una garantía estándar en nuestra mano de obra. Los materiales están cubiertos por la garantía del fabricante.
4. Responsabilidad: C&L Painting está totalmente licenciado y asegurado en el estado de Texas. Cuidamos al máximo su propiedad durante el proyecto.
5. Cancelación: Las cancelaciones deben realizarse al menos 48 horas antes de la fecha de inicio programada.
6. Garantía de Satisfacción: Estamos comprometidos con su satisfacción al 100%. Si algún aspecto de nuestro trabajo no cumple sus expectativas, regresaremos a corregirlo sin costo adicional.`,
      },
      privacy: {
        title: 'Política de Privacidad',
        content: `1. Recopilación de Datos: Recopilamos información personal como nombre, número de teléfono, correo electrónico y dirección únicamente con el fin de proporcionar presupuestos y servicios.
2. Uso de Datos: Su información es utilizada solo por C&L Painting para comunicarnos con usted sobre su proyecto.
3. Terceros: No vendemos, intercambiamos ni transferimos su información personal a terceros.
4. Cookies: Nuestro sitio web puede utilizar cookies para mejorar la experiencia del usuario.
5. Contacto: Para cualquier inquietud relacionada con la privacidad, contáctenos a clpaintingremodeling@gmail.com o al (832) 439-7965.`,
      },
    },
    floatingCta: 'Llame Ahora — Estimado Gratis',
  },
}

export default translations
